module.exports = "/_next/static/images/faq-duotone-75797d26984c7c755e2d588a35a76ac3.svg";